import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { api } from "../../lib/api";
import { useBrand } from "../../contexts/BrandContext";
import SEO from "../../components/SEO";
import { downloadAction } from "../../lib/downloads";

export default function CalibrationPage() {
  const { mode, brand } = useBrand();
  const [items, setItems] = useState([]);
  const [products, setProducts] = useState({});

  useEffect(() => {
    const load = async () => {
      const params = new URLSearchParams();
      if (mode === "brand" && brand) params.set("brand_slug", brand.slug);
      params.set("type", "calibration");
      const [its, ps] = await Promise.all([
        api.get(`/downloads?${params.toString()}`).then((r) => r.data),
        api.get(`/products`).then((r) => r.data),
      ]);
      setItems(its);
      const m = {};
      ps.forEach((p) => (m[p.id] = p));
      setProducts(m);
    };
    load();
  }, [mode, brand]);

  return (
    <div className="fade-in-up" data-testid="calibration-page">
      <SEO title="Kalibrasyon Dosyaları" />
      <div className="border-b border-white/10 py-16 bg-gradient-to-b from-[#0A0A0A] to-[#050505]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-3">Destek</div>
          <h1 className="font-display text-4xl sm:text-5xl tracking-tighter">Kalibrasyon Dosyaları</h1>
          <p className="mt-4 text-zinc-400 max-w-2xl">Ürününüze özel lens profilleri ve kalibrasyon dosyaları.</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        {items.length === 0 ? (
          <div className="text-center py-20 text-zinc-500" data-testid="calibration-empty">
            Henüz kalibrasyon dosyası eklenmemiş.
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="calibration-grid">
            {items.map((d) => {
              const prod = d.product_id ? products[d.product_id] : null;
              const img = d.thumbnail || prod?.images?.[0];
              return (
                <div
                  key={d.id}
                  className="border border-white/10 bg-[#0A0A0A] hover:border-white/30 transition-colors flex flex-col"
                  data-testid={`calibration-card-${d.id}`}
                >
                  <div className="aspect-[16/10] bg-[#141414] flex items-center justify-center p-6">
                    {img ? (
                      <img src={img} alt={d.title} className="max-w-full max-h-full object-contain" />
                    ) : (
                      <div className="text-zinc-700 text-xs uppercase tracking-[0.2em]">No Image</div>
                    )}
                  </div>
                  <div className="p-5 border-t border-white/10 flex-1 flex flex-col">
                    {d.group && (
                      <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-2">{d.group}</div>
                    )}
                    <div className="font-medium text-sm">{d.title}</div>
                    {d.version && <div className="text-xs text-zinc-500 mt-1">{d.version}</div>}
                    <button
                      onClick={() => downloadAction(d)}
                      className="brand-btn mt-4 px-4 py-2.5 text-xs uppercase tracking-[0.2em] inline-flex items-center justify-center gap-2 self-start"
                      data-testid={`calibration-download-${d.id}`}
                    >
                      <Download size={14} /> İndir
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
